"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
// Returns a slightly darker version of the passed in colour
// We use this to make coloured visited links a bit dark to indicate they were visited
// For "night" we return a slightly lighter colour, since it's the darkest in the greyscale options
const getVisitedColour = (colour) => {
    switch (colour) {
        case "blue":
        case "red":
            return tokens_1.COLOURS.primary[colour][130];
        case "night":
            return tokens_1.COLOURS.greyscale.metal;
        case "zinc":
            return tokens_1.COLOURS.greyscale.night;
        case "metal":
            return tokens_1.COLOURS.greyscale.zinc;
        case "white":
            return tokens_1.COLOURS.greyscale.cloud;
        default:
            return colour;
    }
};
exports.StyledText = styled_components_1.default.p `
    ${({ variant }) => tokens_1.TYPOGRAPHY[variant].base}
    ${({ variant }) => tokens_1.TYPOGRAPHY[variant].mobile}
    ${({ skinny }) => skinny && "margin: 0;"}
    
    border: ${({ variant }) => {
    if (variant === "link") {
        return "1px solid transparent";
    }
}};

    color: ${({ colour }) => {
    if (!colour) {
        return null;
    }
    if (colour === "blue" || colour === "red" || colour === "green") {
        return tokens_1.COLOURS.primary[colour][100];
    }
    return tokens_1.COLOURS.greyscale[colour];
}};

    &:visited {
        color: ${({ variant, colour }) => {
    if (!colour) {
        return null;
    }
    if (variant === "link") {
        return getVisitedColour(colour);
    }
}};
    }

    &:hover {
        color: ${({ variant }) => {
    if (variant === "link") {
        return tokens_1.COLOURS.primary.blue["130"];
    }
}};
    }

    &:focus {
        border: 1px solid ${tokens_1.COLOURS.greyscale.night};
        color: ${({ variant }) => {
    if (variant === "link") {
        return tokens_1.COLOURS.primary.blue["130"];
    }
}};
    }

    @media (min-width: ${tokens_1.BREAKPOINTS.md}) {
        ${({ variant }) => tokens_1.TYPOGRAPHY[variant].desktop}
        ${({ skinny }) => skinny && "margin: 0;"}
    }
`;
//# sourceMappingURL=Text.styles.js.map